module.exports = __webpack_public_path__ + "img/safety-build.21a4b568.jpg";